<template>
  <div>
    <div
      v-if="followersExceptCurrentUser.length > 0"
      data-testid="commcard"
      :class="toggleClassWarningState"
      class="sf-commcard-notifications"
    >
      <div>
        <span
          v-for="(user, index) in maxFollowersToShow"
          :key="user.name"
          :class="toggleClassBold(user)"
          data-testid="follower"
          ><span v-if="index != 0">, </span> {{ user.name }}</span
        >
        <span>
          {{
            numberOfHiddenFollowers > 0
              ? I18n.t('communication.comments.notifications.additional', {
                  count: numberOfHiddenFollowers,
                })
              : ''
          }}
          {{ I18n.t('communication.comments.notifications.will_be_notified') }}
        </span>
      </div>
      <div class="fa fa-bell"></div>
    </div>
  </div>
</template>

<script>
import { numberOfNamesShown } from '@app/application/communication/constants'
export default {
  props: {
    followers: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  computed: {
    followersExceptCurrentUser() {
      return Array.from(this.followers)
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .filter((user) => user.id !== parseInt(Silverfin.currentUserId()))
    },

    externalFollowers() {
      return this.followersExceptCurrentUser.filter(
        (user) => user.external === true
      )
    },

    maxFollowersToShow() {
      return this.followersExceptCurrentUser.slice(0, numberOfNamesShown)
    },

    numberOfHiddenFollowers() {
      return (
        this.followersExceptCurrentUser.length - this.maxFollowersToShow.length
      )
    },

    toggleClassWarningState() {
      return {
        'sf-commcard-notifications-warning': this.externalFollowers.length > 0,
      }
    },
  },
  methods: {
    toggleClassBold(user) {
      return { 'sf-font-bold': user.external }
    },
  },
}
</script>
